import { httpClient } from "@/services";

export default {
	state: {
		settingsHolidays: [],
		itemsHolidays: [],
		filtersHolidays: {},
		editHolidays: {},
		createHolidays: {},
	},
	mutations: {
		createHolidays(state, { values }) {
			state.createHolidays = values;
		},
		updateHolidays(state, { settings, items, filters }) {
			state.settingsHolidays = settings;
			state.itemsHolidays = items;
			state.filtersHolidays = filters;
		},
		updateEditHolidays(state, values) {
			state.editHolidays = values;
		},
	},
	actions: {

		async deleteAccountHolidays({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/holidays/${ id }`);
				if (data && data.status) {
					dispatch('getAccountHolidaysList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountHolidaysCreate({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/info/holidays/create");
				if (data) {
					commit('createHolidays', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountHolidaysList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/info/holidays");
				if (data) {
					commit('updateHolidays', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountHolidaysEdit({ commit, dispatch }, values ) {
			try {
				const { id, sendInfo } = values;
				const { data } = await httpClient.put(`/info/holidays/${ id }`, sendInfo);
				if ( data ) {
					commit('updateAccountSettings', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async onAccountHolidaysSave({ commit, dispatch }, args) {
			// dispatch("actionPreloader", true);
			const { sendInfo } = args;
			const { holidays, values } = sendInfo;
			try {
				const { data } = await httpClient.post("/info/holidays", { holidays, values });
				if ( data ) {
					commit('updateAccountSettings', data);
					// dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async getAccountHolidaysEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/holidays/${ id }/edit`);

				if (data && data.status) {
					commit('updateEditHolidays', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},
		// onDefaultList({ commit }) {
		// 	commit('updateDefaultList');
		// }
	},
	getters: {
		editHolidays: s => s.editHolidays,
		settingsHolidays: s => s.settingsHolidays,
		itemsHolidays: s => s.itemsHolidays,
		filtersHolidays: s => s.filtersHolidays,
		createHolidays: s => s.createHolidays,
	},
};
